<template>
  <main class="home">
    <section class="hero hero--compare" style="background-image:url(/images/home_bg.jpg)">

      <div class="hero__layer"></div>

      <div class="hero__main">
        <div class="container container--md">

          <div class="comparison">
            <div class="comparison__search">
              <div class="comparison__block">
                <autocomplete
                ref="autocomplete1"
                :class="'compare_autocomplete'"
                source="/api/members-search?q="
                placeholder="1o όνομα"
                resultsValue="id"
                :results-display="formattedMemberDisplay"
                @selected="selectMember1"
                @clear="clearMember1"
                @results="member1.data = null"
                @input="alert()"
                >
                  <li slot="noResults">Δεν βρέθηκαν αποτελέσματα..</li>
                </autocomplete>
              </div>
              <div class="comparison__block">
                <autocomplete
                ref="autocomplete2"
                source="/api/members-search?q="
                placeholder="2o όνομα"
                resultsValue="id"
                :results-display="formattedMemberDisplay"
                @selected="selectMember2"
                @clear="clearMember2"
                @results="member2.data = null"
                >
                  <li slot="noResults">Δεν βρέθηκαν αποτελέσματα..</li>
                </autocomplete>
              </div>
            </div>

            <div class="comparison__cards">
              <div class="comparison__block">
                <div class="comparison__card" :class="{ 'comparison__card--empty' : !member1.data }">
                  <div class="comparison__card__main">
                    <h2 class="comparison__card__title" v-if="member1.data">{{ `${member1.data.first_name} ${member1.data.last_name}`  }}</h2>
                    <h2 class="comparison__card__title" v-else>Ονοματεπώνυμο Βουλευτή</h2>
                    <div class="drop-down-filter drop-down-filter--border" v-if="member1.active_fiscal_year">
                      <div class="toggle"><span>{{ member1.active_fiscal_year }}</span> <i class="fa fa-chevron-down"></i></div>
                      <ul>
                        <li v-for="(year, key) in member1.fiscal_years" v-bind:key="key+year+'f_member_1years'+Math.floor(Math.random() * 99999)">
                          <a href="#" :class="{ 'active' : year == member1.active_fiscal_year}" @click.prevent="setActiveYear1(year)">{{ year }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="comparison__card__details">
                      <p>ΚΟΜΜΑ  <a :href="`https://vouliwatch.gr/parties/${member1.data.fiscal[0].politicalparty.slug}`" target="_blank" v-if="member1.data"> {{ member1.data.fiscal[0].politicalparty.name }}</a></p>
                      <p>ΚΟΙΝΟΒΟΥΛΕΥΤΙΚΗ ΟΜΑΔΑ   <span v-if="member1.data"> {{ member1.data.fiscal[0].politicalparty.name }}</span></p>
                      <p>ΚΥΒΕΡΝΗΤΙΚΗ ΘΕΣΗ   <span v-if="member1.data && member1.data.fiscal[0].goverment_position">{{ member1.data.fiscal[0].goverment_position.name }}</span><span v-else-if="member1.data">Βουλευτής</span></p>
                      <p v-if="member1.data && member1.data.fiscal[0].parliament_office">ΚΟΙΝΟΒΟΥΛΕΥΤΙΚΗ ΘΕΣΗ   <span>{{ member1.data.fiscal[0].parliament_office.name }}</span></p>
                      <p>ΠΕΡΙΦΕΡΕΙΑ   <a :href="`https://vouliwatch.gr/districts/${member1.data.electoral_districts[0].slug}`" target="_blank" v-if="member1.data && member1.data.electoral_districts[0]">{{ member1.data.electoral_districts[0].name }}</a></p>
                    </div>

                  </div>
                  <div class="comparison__card__image">
                    <div class="photo-icon photo-icon--100" v-if="member1.data" :style="{ backgroundImage: 'url(' + getProfileImage(member1.data.profile_image) + ')' }"></div>
                    <div class="photo-icon photo-icon--empty photo-icon--100" v-else style="background-image: url('/images/no-icon2.svg');"></div>
                  </div>
                </div>
              </div>
              <div class="comparison__block">
                <div class="comparison__card" :class="{ 'comparison__card--empty' : !member2.data }">
                  <div class="comparison__card__main">
                    <h2 class="comparison__card__title" v-if="member2.data">{{ `${member2.data.first_name} ${member2.data.last_name}`  }}</h2>
                    <h2 class="comparison__card__title" v-else>Ονοματεπώνυμο Βουλευτή</h2>
                    <div class="drop-down-filter drop-down-filter--border" v-if="member2.active_fiscal_year">
                      <div class="toggle"><span>{{ member2.active_fiscal_year }}</span> <i class="fa fa-chevron-down"></i></div>
                      <ul>
                        <li v-for="(year, key) in member2.fiscal_years" v-bind:key="key+year+'f_member_2years'+Math.floor(Math.random() * 99999)">
                          <a href="#" :class="{ 'active' : year == member2.active_fiscal_year}" @click.prevent="setActiveYear2(year)">{{ year }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="comparison__card__details">
                      <p>ΚΟΜΜΑ  <a :href="`https://vouliwatch.gr/parties/${member2.data.fiscal[0].politicalparty.slug}`" target="_blank" v-if="member2.data"> {{ member2.data.fiscal[0].politicalparty.name }}</a></p>
                      <p>ΚΟΙΝΟΒΟΥΛΕΥΤΙΚΗ ΟΜΑΔΑ   <span v-if="member2.data"> {{ member2.data.fiscal[0].politicalparty.name }}</span></p>
                      <p>ΚΥΒΕΡΝΗΤΙΚΗ ΘΕΣΗ   <span v-if="member2.data && member2.data.fiscal[0].goverment_position">{{ member2.data.fiscal[0].goverment_position.name }}</span><span v-else-if="member2.data">Βουλευτής</span></p>
                      <p>ΠΕΡΙΦΕΡΕΙΑ   <a :href="`https://vouliwatch.gr/districts/${member2.data.electoral_districts[0].slug}`" target="_blank" v-if="member2.data && member2.data.electoral_districts[0]">{{ member2.data.electoral_districts[0].name }}</a></p>
                    </div>

                  </div>
                  <div class="comparison__card__image">
                    <div class="photo-icon photo-icon--100" v-if="member2.data" :style="{ backgroundImage: 'url(' + getProfileImage(member2.data.profile_image) + ')' }"></div>
                    <div class="photo-icon photo-icon--empty photo-icon--100" v-else style="background-image: url('/images/no-icon2.svg');"></div>
                  </div>
                </div>
              </div>

            </div>

            <compare-charts v-if="member1.data && member2.data" :member1="member1.data" :member2="member2.data" :max_values="max_values"></compare-charts>

          </div>

        </div>
      </div>
    </section>

    <section class="cards" v-if="member1.data || member2.data">
      <div class="fixed-compare fixed-compare--mobile">
        <div class="container container--md">
          <div class="fixed-compare__wrapper">

            <div class="fixed-compare__block">
              <div class="comparison__search">
                  <autocomplete
                  ref="autocomplete1_a"
                  source="/api/members-search?q="
                  placeholder="1o όνομα"
                  resultsValue="id"
                  :results-display="formattedMemberDisplay"
                  @selected="selectMember1"
                  @clear="clearMember1"
                  @results="member1.data = null"
                  >
                    <li slot="noResults">Δεν βρέθηκαν αποτελέσματα..</li>
                  </autocomplete>
              </div>
              <div class="drop-down-filter drop-down-filter--border" v-if="member1.active_fiscal_year">
                <div class="toggle"><span>{{ member1.active_fiscal_year }}</span> <i class="fa fa-chevron-down"></i></div>
                <ul>
                  <li v-for="(year, key) in member1.fiscal_years" v-bind:key="key+year+'f_member_1_menuyears'+Math.floor(Math.random() * 99999)">
                    <a href="#" :class="{ 'active' : year == member1.active_fiscal_year}" @click.prevent="setActiveYear1(year)">{{ year }}</a>
                  </li>
                </ul>
              </div>
              <div v-else class="drop-down-filter drop-down-filter--border drop-down-filter--empty">
                <div class="toggle"><span>2019</span> <i class="fa fa-chevron-down"></i></div>
                <ul><li><a href="#">2019</a></li></ul>
              </div>
              <div class="photo-icon photo-icon--50" v-if="member1.data" :style="{ backgroundImage: 'url(' + getProfileImage(member1.data.profile_image) + ')' }"></div>
              <div class="photo-icon photo-icon--empty photo-icon--50" v-else style="background-image: url('/images/no-icon2.svg');"></div>
            </div>

            <div class="fixed-compare__block">
              <div class="comparison__search">
                  <autocomplete
                  ref="autocomplete2_a"
                  source="/api/members-search?q="
                  placeholder="2o όνομα"
                  resultsValue="id"
                  :results-display="formattedMemberDisplay"
                  @selected="selectMember2"
                  @clear="clearMember2"
                  @results="member1.data = null"
                  >
                    <li slot="noResults">Δεν βρέθηκαν αποτελέσματα..</li>
                  </autocomplete>
              </div>

              <div class="drop-down-filter drop-down-filter--border" v-if="member2.active_fiscal_year">
                <div class="toggle"><span>{{ member2.active_fiscal_year }}</span> <i class="fa fa-chevron-down"></i></div>
                <ul>
                  <li v-for="(year, key) in member2.fiscal_years" v-bind:key="key+year+'f_member_2_menuyears'+Math.floor(Math.random() * 99999)">
                    <a href="#" :class="{ 'active' : year == member2.active_fiscal_year}" @click.prevent="setActiveYear2(year)">{{ year }}</a>
                  </li>
                </ul>
              </div>
              <div v-else class="drop-down-filter drop-down-filter--border drop-down-filter--empty">
                <div class="toggle"><span>2019</span> <i class="fa fa-chevron-down"></i></div>
                <ul><li><a href="#">2019</a></li></ul>
              </div>

              <div class="photo-icon photo-icon--50" v-if="member2.data" :style="{ backgroundImage: 'url(' + getProfileImage(member2.data.profile_image) + ')' }"></div>
              <div class="photo-icon photo-icon--empty photo-icon--50" v-else style="background-image: url('/images/no-icon2.svg');"></div>
            </div>


          </div>
        </div>
      </div>

      <div class="cards__filters cards__filters--compare">
        <div class="cards__filters__toggle">
          <p class="cards__filters__toggle__label" :class="{active : !partner }">ΒΟΥΛΕΥΤΗΣ</p>
          <label class="switch">
            <input type="checkbox" v-model="partner">
            <span class="slider round"></span>
          </label>
          <p class="cards__filters__toggle__label" :class="{active : partner }">ΣΥΖΥΓΟΣ</p>
        </div>

        <div class="cards__filters__menu">
          <scrollactive class="my-nav" active-class="active" :modifyUrl="false" :offset="150">
          <ul>
            <li><a href="#revenues" class="scrollactive-item">ΕΙΣΟΔΗΜΑΤΑ</a></li>
            <li><a href="#stocks" class="scrollactive-item">ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</a></li>
            <li><a href="#deposits" class="scrollactive-item">ΚΑΤΑΘΕΣΕΙΣ</a></li>
            <li><a href="#loans" class="scrollactive-item">ΔΑΝΕΙΑΚΕΣ ΥΠΟΧΡΕΩΣΕΙΣ & ΟΦΕΙΛΕΣ</a></li>
            <li><a href="#companies" class="scrollactive-item">ΣΥΜΜΕΤΟΧΗ ΣΕ ΕΠΙΧΕΙΡΗΣΕΙΣ</a></li>
            <li><a href="#properties" class="scrollactive-item">ΑΚΙΝΗΤΑ</a></li>
            <li><a href="#vehicles" class="scrollactive-item">ΟΧΗΜΑΤΑ</a></li>
          </ul>
          </scrollactive>
        </div>
      </div>

      <div class="cards__main">
        <div class="container container--lg">

          <div class="cards__row">
            <div class="cards__block cards__block--half desktop">
              <!-- <p class="cards__block__top">38 ΠΑΡΑΛΗΨΕΙΣ</p> -->
            </div>
            <div class="cards__block cards__block--half cards__block--empty desktop">
              <!-- <p class="cards__block__top">ΠΑΡΑΛΗΨΕΙΣ</p> -->
            </div>
            <p class="cards__block__top cards__block__top--black mobile">Βλέπετε μια συνοπτική καταγραφή των δεδομένων της
              σύγκρισης των δηλώσεων Πόθεν Έσχες των βουλευτών.
              Για την αναλυτική έκδοση επισκεφτείτε την ιστοσελίδα
              από desktop.</p>
          </div>

          <div class="cards__compare">
            <member-tables v-if="member1.data" :memberfiscal="member1.data ? member1.data.fiscal[0] : member1.data" :partner="partner" :isHalf="true" :isEmpty="false"></member-tables>
            <div v-else class="cards__block cards__block--half cards__block--empty">
              <div class="card" id="revenues"><h3 class="card__title">ΕΙΣΟΔΗΜΑΤΑ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="stocks"><h3 class="card__title">ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="deposits"><h3 class="card__title">ΚΑΤΑΘΕΣΕΙΣ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="loans"><h3 class="card__title">Δανειακες υποχρεωσεις και οφειλες</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="companies"><h3 class="card__title">Συμμετοχη σε επιχειρησεις</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="properties"><h3 class="card__title">Ακινητα</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="vehicles"><h3 class="card__title">ΟΧΗΜΑΤΑ</h3><div class="card__table"><table></table></div></div>
            </div>
            <member-tables v-if="member2.data" :memberfiscal="member2.data ? member2.data.fiscal[0] : member2.data" :partner="partner" :isHalf="true" :isEmpty="false"></member-tables>
            <div v-else class="cards__block cards__block--half cards__block--empty">
              <div class="card" id="revenues"><h3 class="card__title">ΕΙΣΟΔΗΜΑΤΑ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="stocks"><h3 class="card__title">ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="deposits"><h3 class="card__title">ΚΑΤΑΘΕΣΕΙΣ</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="loans"><h3 class="card__title">Δανειακες υποχρεωσεις και οφειλες</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="companies"><h3 class="card__title">Συμμετοχη σε επιχειρησεις</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="properties"><h3 class="card__title">Ακινητα</h3><div class="card__table"><table></table></div></div>
              <div class="card" id="vehicles"><h3 class="card__title">ΟΧΗΜΑΤΑ</h3><div class="card__table"><table></table></div></div>
            </div>
          </div>

          <div class="cards__bottom">
            <a href="/compare" class="btn btn--std">NEA ΣΥΓΚΡΙΣΗ</a>
          </div>

        </div>
      </div>
    </section>
  </main>
</template>

<script>
import $ from 'jquery'
import Autocomplete from 'vuejs-auto-complete'
import MemberTables from "../components/MemberTables"

import CompareCharts from "../components/CompareCharts"
export default {
  components: {
    Autocomplete,
    MemberTables,
    CompareCharts
  },
  data() {
      return {
        partner: false,
        AC_SELECTOR: '',
        member1: {
          slug: '',
          active_fiscal_year: null,
          fiscal_years: [],
          data: null,
        },
        member2: {
          slug: null,
          active_fiscal_year: null,
          fiscal_years: [],
          data: null
        },
        max_values: {
          total_revenue: 0,
          total_deposits: 0,
          total_properties: 0,
          total_stocks: 0,
          total_mobiles: 0,
          total_companies: 0,
          total_loans: 0,
        },
        loading: false,
      }
  },
  mounted() {
    this.$nextTick(function () {
      this.initUI();
    })
    this.loading = false;
    this.$emit("updateLoader", this.loading);
    if(this.$route.query.member1) {
      this.member1.slug = this.$route.query.member1;
      this.getMember(this.member1.slug, this.member1.active_fiscal_year)
    }
    if(this.$route.query.member2) {
      this.member2.slug = this.$route.query.member2;
      this.getMember(this.member2.slug, this.member2.active_fiscal_year)
    }
  },
  updated() {
  },
  methods: {
    getMember(slug, year) {
      this.loading = true;
      this.$emit("updateLoader", this.loading);
      const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      axios.post('/api/member', {
          data: {
           year: year,
           slug: slug
          }
      })
      .then((response) => {
        if(slug == this.member1.slug && this.member1.active_fiscal_year == year) {
          this.member1.data = response.data.member;
          this.member1.fiscal_years = response.data.fiscal_totals.map(a => a.year_of_use);
          this.member1.active_fiscal_year = this.member1.data.fiscal[0].year_of_use;
          this.calculateMaxValues();
        }
        if(slug == this.member2.slug && this.member2.active_fiscal_year == year) {
          this.member2.data = response.data.member;
          this.member2.fiscal_years = response.data.fiscal_totals.map(a => a.year_of_use);
          this.member2.active_fiscal_year = this.member2.data.fiscal[0].year_of_use;
          this.calculateMaxValues();
        }
        this.loading = false;
        this.$emit("updateLoader", this.loading);
        this.$nextTick(function () {
          this.$refs.autocomplete1.$el.children[0].children[1].children[0].value = this.member1name;
          this.$refs.autocomplete2.$el.children[0].children[1].children[0].value = this.member2name;
          this.$refs.autocomplete1_a.$el.children[0].children[1].children[0].value = this.member1name;
          this.$refs.autocomplete2_a.$el.children[0].children[1].children[0].value = this.member2name;
          this.tableSizes();
        });
      })
      .catch((error) => {
          this.loading = false;
          this.$emit("updateLoader", this.loading);
      });
    },
    getProfileImage(profile_image){
      if(profile_image != ' ') {
        return profile_image;
      }
      return '/images/default_profile_image.svg'
    },

    setActiveYear1(year) {
      this.member1.active_fiscal_year = year;
      this.getMember(this.member1.slug, this.member1.active_fiscal_year);
    },
    setActiveYear2(year) {
      this.member2.active_fiscal_year = year;
      this.getMember(this.member2.slug, this.member2.active_fiscal_year)
    },
    formattedMemberDisplay (result) {
      return result.first_name + ' ' + result.last_name;
    },
    selectMember1(member) {
      this.setUrlParameter('member1', member.selectedObject.slug)
      this.member1.slug = member.selectedObject.slug;
      this.member1.active_fiscal_year = null;
      this.getMember(this.member1.slug, this.member1.active_fiscal_year)
    },
    selectMember2(member) {
      this.setUrlParameter('member2', member.selectedObject.slug)
      this.member2.slug = member.selectedObject.slug;
      this.member2.active_fiscal_year = null;
      this.getMember(this.member2.slug, this.member2.active_fiscal_year)
    },
    clearMember1() {
      this.member1 =  { slug: null, active_fiscal_year: null, fiscal_years: [], data: null};
    },
    clearMember2() {
      this.member2 =  { slug: null, active_fiscal_year: null, fiscal_years: [], data: null};
    },

    setUrlParameter(key, value) {
      if (!window.history.pushState) return;
      if (!key) return;
      var url = new URL(window.location.href);
      var params = new window.URLSearchParams(window.location.search);
      if (value === undefined || value === null) {
          params.delete(key);
      } else {
          params.set(key, value);
      }
      url.search = params;
      url = url.toString();
      window.history.replaceState({url: url}, null, url);
    },

    initUI() {
      $('body').on('click', '.drop-down-filter .toggle', function(e) {
        e.stopPropagation();
        $(this).parent().toggleClass('open');
      });
      $( ".drop-down-filter ul li input" ).click(function(e) {
        e.stopPropagation();
      });
      $( ".drop-down-filter label, .drop-down-filter input" ).click(function(e) {
        e.stopPropagation();
      });
      $(document).click(function(){
        $( ".drop-down-filter" ).removeClass('open');
      });

      $(window).scroll(function(){
        if(!$('.fixed-compare').length) return;
        var from_top = $('.cards__filters').offset().top;
        if($(this).scrollTop()>=from_top-70){
          $('.fixed-compare').addClass('active');
          $('.cards__filters').addClass('active');
        }
        else{
          $('.fixed-compare').removeClass('active');
          $('.cards__filters').removeClass('active');
        }
      });
    },
    tableSizesReset(table_classes) {
      table_classes.forEach((className, index) => {
        $('.'+className).css({'min-height': 0+'px'})
      });
    },
    tableSizes() { //hacky fix for table equal table heights
      const table_classes = ['revenues', 'stocks', 'deposits', 'loans', 'companies', 'properties', 'vehicles']
      this.tableSizesReset(table_classes)
      table_classes.forEach((className, index) => {
        let max_height = 0;
        $('.'+className).each(function() {
          if($(this).height() > max_height) {
            max_height = $(this).outerHeight(true);
          }
        });
        $('.'+className).css({'min-height': max_height+'px'})
      });
    },

    calculateMaxValues() {
      if(!this.member1.data && !this.member2.data ) return;
      Object.keys(this.max_values).forEach(key => {
        this.max_values[key] = this.maxValue(key);
      });
    },
    maxValue(type) {
      let max = Math.max( parseFloat( this.member1.data.fiscal[0][type]), parseFloat(this.member2.data.fiscal[0][type]) );
      return max + (max * 20 / 100); //add an extra % in order for values to show properly
    }
  },
  computed: {
    member1name: function() {
      if(this.member1.data) {
        return `${this.member1.data.first_name} ${this.member1.data.last_name}`;
      }
      return '';
    },
    member2name: function() {
      if(this.member2.data) {
          return `${this.member2.data.first_name} ${this.member2.data.last_name}`;
      }
      return '';
    },
  },
  watch: {
    $route: {
        immediate: true,
        handler(to, from) {
            document.title = 'Σύγκριση | πόθεν έσχες - vouliwatch';
        }
    },
  }
}
</script>
